define('location',[
    "jquery",
    "logging",
    "storage",
    "utilities"
], function ($, logging, storage, utilities) {
    var _ModuleName = "Location Library";

    var _config = {
        api: {
            endpoint: "https://www.beliefnet.com/bnapi/location/findme"
        },
        cache: {
            enable: true,
            names: {
                euCheck: "eucheck"
            }
        },
        testing: {
            enabled: true,
            param: "bnet-force-location",
            locations: {
                europeanunion: "eu"
            }
        }
    };

    var isEuropeanUnion = function (istrue, isfalse) {
        logging.debug("Got a request to check if we're in the European Union", _ModuleName);
        if (_config.cache.enable) {
            var cache = storage.getSessionStorage(_config.cache.names.euCheck);
            if (typeof( cache ) == 'boolean') {
                logging.debug("Found location response in session cache [" + cache + "]", _ModuleName);

                _handleResponseIsEuropeanUnion(cache, istrue, isfalse);
                return ;
            }
        }

        logging.debug("Sending Request to API endpoint", _ModuleName);
        $.get(_config.api.endpoint, function (result) {
            logging.debug("Response returned from location api", _ModuleName);
            _handleResponseIsEuropeanUnion(result.InEU, istrue, isfalse);
        });
    }
    
    var _handleResponseIsEuropeanUnion = function (response, istrue, isfalse) {
        if (_config.testing.enabled && utilities.getParameter(document.URL, _config.testing.param) == _config.testing.locations.europeanunion) {
            logging.debug("GDPR Testing Enabled and Requested. Overriding location response", _ModuleName);
            response = true;
        }

        if (response && typeof (istrue) == 'function') {
            logging.debug("Location: European Union", _ModuleName);
            storage.setSessionStorage(_config.cache.names.euCheck, true);
            istrue();
        } else if (response === false && typeof (isfalse) == 'function') {
            logging.debug("Location: Not European Union", _ModuleName);
            storage.setSessionStorage(_config.cache.names.euCheck, false);
            isfalse();
        } else {
            logging.error("Something went wrong with getting your information", _ModuleName);
        }
    }

    return {
        isEuropeanUnion: isEuropeanUnion
    }
});
